import { z } from 'zod';
import { requiredString, textWithinLimit } from '@/shared/lib/validation';

/** Проверяет название папки или шаблона */
const nameSchema = textWithinLimit(100, 'Название должно содержать не больше 100 символов', { trim: true })
    .pipe(requiredString('Укажите название'));

/** Проверяет папку шаблонов сообщений */
export const chatReplyFolderSchema = z.object({
    name: nameSchema,
    parentId: z.string()
        .nullable(),
});

/** Проверяет шаблон сообщения чата */
export const chatReplyTemplateSchema = z.object({
    name: nameSchema,
    folderId: z.string()
        .uuid('Выберите папку'),
    text: textWithinLimit(4000, 'Сообщение должно содержать не больше 4000 символов')
        .pipe(requiredString('Укажите текст сообщения', {
            trim: false,
            rejectWhitespace: true,
        })),
});

/** Значения формы папки */
export type ChatReplyFolderValues = z.infer<typeof chatReplyFolderSchema>;

/** Значения формы шаблона сообщения */
export type ChatReplyTemplateValues = z.infer<typeof chatReplyTemplateSchema>;
